import React from 'react';

import ImageModalTool from '../imageModalTool/ImageModalTool';

type ImageEditToolProps = Omit<React.ComponentProps<typeof ImageModalTool>, 'mode'>;

/**
 * Opens the image modal crop/edit tools for a selected image.
 */
const ImageEditTool: React.FC<ImageEditToolProps> = (props) => <ImageModalTool {...props} mode="edit" />;

export default ImageEditTool;
